import Abstract from './_abstract.js';
import Twig from 'twigjs';
import Choice from './_choice.js';

class Swiftype extends Abstract {

	addChoices() {
		super.addChoices();

		this.choices.topic = new Choice( '.filters__filter--topic select', {
			onChange: ( value ) => {
				this.params.paged = 1;
				this.params.filters.topic = value;
				this.load();
			},
			formatOption: ( option ) => {
				option.label = `${option.label} (${option.count})`;
				return option;
			},
			choices: {
				noChoicesText: 'No more topics to filter',
				placeholderValue: 'Select a topic',
			}
		} );

		this.choices.domain = new Choice( '.filters__filter--domain select', {
			onChange: ( value ) => {
				this.params.paged = 1;
				this.params.filters.domain = value;
				this.load();
			},
			choices: {
				noChoicesText: 'No more communities to filter',
				placeholderValue: 'Select a Community',
			}
		} );
	}

	loadTemplates() {
		Twig.twig( {
			id: 'pagination',
			href: '/wp-content/themes/kendal/views/partials/pagination.twig',
		} );

		Twig.twig( {
			id: 'result',
			href: '/wp-content/themes/kendal/views/partials/search/swiftype-kcard.twig',
		} );
	}

	getParamsFromURL() {
		const urlParams = super.getParamsFromURL();

		urlParams.forEach( ( value, key ) => {
			let filterMatch = key.match( /^filters\[([^\]]+)\]\[\]$/ );

			if ( filterMatch ) {
				this.params.filters[ filterMatch[1] ] = value;
			} else {
				switch( key ) {
					case 'sort_field':
						this.params.sortField = value;
					break;
					case 'sort_direction':
						this.params.sortDirection = value || 'desc';
					break;
				}
			}
		} );

		this.unlisten();

		for ( let choice in this.choices ) {
			if ( this.choices.hasOwnProperty( choice ) && this.params.filters[ choice ] ) {
				this.choices[ choice ].setValue( this.params.filters[ choice ] );
			}
		}

		this.listen();

		return this.params;
	}

	getQueryString() {
		// build our query string from our filters
		let queryString = '';

		queryString += `q=${encodeURIComponent(this.params.q)}`;
		queryString += `&sort_field=${encodeURIComponent(this.params.sortField)}`;
		queryString += `&sort_direction=${encodeURIComponent(this.params.sortDirection)}`;

		if ( this.opts.requireTopic ) {
			queryString += '&require_topic=1';
		}

		if ( this.params.paged > 1 ) {
			queryString += `&paged=${this.params.paged}`;
		}

		for ( let filter in this.params.filters ) {
			if ( this.params.filters.hasOwnProperty( filter ) && this.params.filters[ filter ] ) {
				queryString += `&filters[${ filter }][]=${encodeURIComponent( this.params.filters[ filter ] ) }`
			}
		}

		return queryString;
	}

	/**
	 * add json parameter to our url to accept json results instead of a search results page
	 */
	getXhrUrl( queryString ) {
		return `/?${queryString}&json=1`;
	}

}

export default Swiftype;
